module.exports = __webpack_public_path__ + "static/shopping-cart (1)-bb3e5ecf758bad14769d7f17927d1239.png";